import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { translations } from './translations';

const languageMap = {
  english: 'en',
  spanish: 'es',
  french: 'fr',
  german: 'de',
  italian: 'it',
  chinese: 'zh',
  arabic: 'ar',
  russian: 'ru',
  japanese: 'ja',
  hindi: 'hi',
  albanian: 'sq',
  en: 'en',
  es: 'es',
  fr: 'fr',
  de: 'de',
  it: 'it',
  zh: 'zh',
  ar: 'ar',
  ru: 'ru',
  ja: 'ja',
  hi: 'hi',
  sq: 'sq'
};

const getPathValue = (obj, path) => {
  return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
};

export const normalizeLanguage = (value) => {
  if (!value) return 'en';
  const key = String(value).trim().toLowerCase();
  return languageMap[key] || 'en';
};

const inferInitialLanguage = () => {
  const stored = localStorage.getItem('uiLanguage');
  if (stored) return normalizeLanguage(stored);

  try {
    const currentUserRaw = localStorage.getItem('currentUser');
    const currentUser = currentUserRaw ? JSON.parse(currentUserRaw) : null;
    if (currentUser?.learningLanguage) return normalizeLanguage(currentUser.learningLanguage);
  } catch (error) {
  }

  return 'en';
};

const LanguageContext = createContext({
  language: 'en',
  setLanguage: () => {},
  t: (key) => key,
});

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(inferInitialLanguage);

  const setLanguage = (value) => {
    const normalized = normalizeLanguage(value);
    setLanguageState(normalized);
    localStorage.setItem('uiLanguage', normalized);
    document.documentElement.lang = normalized;
  };

  const t = useCallback((key, fallback = '') => {
    const langPack = translations[language] || {};
    const enPack = translations.en || {};
    const value = getPathValue(langPack, key);
    if (typeof value === 'string' && value.length > 0) return value;

    const enValue = getPathValue(enPack, key);
    if (typeof enValue === 'string' && enValue.length > 0) return enValue;

    return fallback || key;
  }, [language]);

  const contextValue = useMemo(() => ({ language, setLanguage, t }), [language, t]);

  return <LanguageContext.Provider value={contextValue}>{children}</LanguageContext.Provider>;
};

export const useI18n = () => useContext(LanguageContext);
